'use es6';

var newRelicAvailabile = function newRelicAvailabile() {
  return Boolean(window.newrelic);
};

export var MARK_USER_INFO_START = 'mark_user_info_start';
export var MARK_USER_INFO_SUCCESS = 'mark_user_info_success';
export var MEASURE_USER_INFO_TIME = 'measure_user_info_time';
export var MEASURE_API_VERIFY_TIME = 'measure_api_verify_time';
export var setCustomAttribute = function setCustomAttribute(name, value) {
  if (newRelicAvailabile()) {
    window.newrelic.setCustomAttribute(name, value);
  }
};